"use strict";module.exports="undefined"!=typeof Reflect&&Reflect&&Reflect.apply;